import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 Shore Shine Window Cleaning</p>
    </footer>
  );
};

export default Footer;
